var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgComputerWithHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Laptop-Heart--Streamline-Ultimate"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M37.9098 32.6363C38.0648 32.9478 38.1376 33.2938 38.1214 33.6414C38.1052 33.989 38.0005 34.3267 37.8172 34.6225C37.634 34.9183 37.3782 35.1624 37.0741 35.3317C36.7701 35.5009 36.4278 35.5897 36.0798 35.5896H5.16984C4.82072 35.5911 4.47703 35.5031 4.17162 35.334C3.86621 35.1648 3.60928 34.9202 3.42537 34.6234C3.24146 34.3267 3.13673 33.9877 3.12117 33.6389C3.10561 33.2902 3.17975 32.9432 3.3365 32.6313L5.62484 25.5896H35.6248L37.9098 32.6363Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M33.1248 5.5896C33.7878 5.5896 34.4237 5.85299 34.8925 6.32183C35.3614 6.79067 35.6248 7.42656 35.6248 8.0896V25.5896H5.63477V8.0896C5.63477 7.42656 5.89816 6.79067 6.367 6.32183C6.83584 5.85299 7.47172 5.5896 8.13477 5.5896",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.375 30.5913H21.875",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M20.6252 20.5896L13.3202 12.9746C12.68 12.3322 12.2575 11.5052 12.1121 10.61C11.9668 9.71475 12.1061 8.7965 12.5102 7.9846C12.8167 7.37232 13.2642 6.84158 13.8159 6.4361C14.3677 6.03061 15.0078 5.76196 15.6837 5.65227C16.3595 5.54258 17.0518 5.59499 17.7034 5.80518C18.3551 6.01538 18.9475 6.37734 19.4319 6.86127L20.6252 8.0546L21.8185 6.86127C22.3029 6.37734 22.8953 6.01538 23.547 5.80518C24.1986 5.59499 24.8909 5.54258 25.5667 5.65227C26.2426 5.76196 26.8827 6.03061 27.4345 6.4361C27.9862 6.84158 28.4337 7.37232 28.7402 7.9846C29.1461 8.7961 29.2863 9.71477 29.1409 10.6104C28.9956 11.506 28.572 12.3332 27.9302 12.9746L20.6252 20.5896Z",
    stroke: "#101820",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerWithHeart);
export default __webpack_public_path__ + "static/media/computerWithHeart.2fa639d5dc4fbb46642a20e02b363a77.svg";
export { ForwardRef as ReactComponent };